module.exports = __webpack_public_path__ + "img/icon-fom-create-form.7df55162.png";